import axios from 'axios'
import { BASE_URL } from './api'

export async function listExpenseTags(token, q = '') {
    const params = new URLSearchParams()
    if (q) params.set('q', q)
    const url = `${BASE_URL}/expense-tags/${params.toString() ? `?${params.toString()}` : ''}`
    return axios({
        method: 'get',
        url,
        headers: { Authorization: `Token ${token}` },
    }).then((response) => response.data)
}

export async function createExpenseTag(name, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-tags/`,
        headers: { Authorization: `Token ${token}`, 'Content-Type': 'application/json' },
        data: { name },
    }).then((response) => response.data)
}

export async function renameExpenseTag(tagId, name, token) {
    return axios({
        method: 'patch',
        url: `${BASE_URL}/expense-tags/${tagId}/`,
        headers: { Authorization: `Token ${token}`, 'Content-Type': 'application/json' },
        data: { name },
    }).then((response) => response.data)
}

export async function deleteExpenseTag(tagId, token) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/expense-tags/${tagId}/`,
        headers: { Authorization: `Token ${token}` },
    }).then((response) => response)
}

export async function addTagsToExpense(expenseId, names, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/${expenseId}/add-tags/`,
        headers: { Authorization: `Token ${token}`, 'Content-Type': 'application/json' },
        data: { names },
    }).then((response) => response.data)
}

export async function removeTagFromExpense(expenseId, tagId, token) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/expense-records/${expenseId}/tags/${tagId}/`,
        headers: { Authorization: `Token ${token}` },
    }).then((response) => response.data)
}

export async function bulkAddTagsToExpenses(expenseIds, tagNames, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-add-tags/`,
        headers: { Authorization: `Token ${token}`, 'Content-Type': 'application/json' },
        data: { expense_ids: expenseIds, tag_names: tagNames },
    }).then((response) => response.data)
}

export async function bulkRemoveTagsFromExpenses(expenseIds, { tagNames = [], tagIds = [] }, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-records/bulk-remove-tags/`,
        headers: { Authorization: `Token ${token}`, 'Content-Type': 'application/json' },
        data: { expense_ids: expenseIds, tag_names: tagNames, tag_ids: tagIds },
    }).then((response) => response.data)
}

// A rejected tag write comes back field-keyed (e.g. {names: ["..."]}), which
// the generic error formatters render as raw JSON. Pull the first string out.
export function tagErrorMessage(error) {
    const data = error?.response?.data
    if (!data) return null
    if (typeof data === 'string') return data
    for (const value of [data.names, data.tag_names, data.name, data.detail]) {
        if (typeof value === 'string') return value
        if (Array.isArray(value) && typeof value[0] === 'string') return value[0]
    }
    return null
}

// Mirrors RETIRED_TAG_NAMES in expense/models.py. Kept client-side so the
// picker never offers a name the server will reject, and so a blocked tag
// stops the save before the expense row is written.
export const RETIRED_TAG_NAMES = ['retro']

export function isRetiredTagName(name) {
    return RETIRED_TAG_NAMES.includes((name || '').trim().toLowerCase())
}
